import {
  Link,
  VStack,
} from '@ayble-health/dashboard-components';
import { useEffect } from 'react';
import { useDashboardPageState } from '../../../hooks/useDashboardPageState';
import { ExternalLinkIcon } from 'lucide-react';

const { REACT_APP_HEALTHIE_URL } = process.env;

export const LabsDocumentsPage = () => {
  const {
    state: { user },
  } = useDashboardPageState();

  const openLabsInHealthie = () => {
    // launch labs in new window
    const labUrl = user?.healthie_id
      ? `${REACT_APP_HEALTHIE_URL}/lab_orders/?clients=${user.healthie_id}`
      : null;
    if (labUrl) {
      window.open(labUrl, 'healthie');
    }
  };

  useEffect(() => {
    // open new Healhie window when page mounts
    openLabsInHealthie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <VStack h={'100%'} minH={'50vh'} flex={1} align={'center'} justify={'space-evenly'}>
      <Link onClick={openLabsInHealthie} color={'bluegrey'}>
        Open labs in Healthie
        <ExternalLinkIcon size={16} />
      </Link>
    </VStack>
  );
};

export default LabsDocumentsPage;
